/** Curated worlds shown on the home landing — queries are kid-friendly starters for web search. */
const HIDDEN_UNTIL_GUIDED_LESSONS = new Set(['oceans', 'science-lab']);

const ALL_EXPLORE_WORLDS = [
  {
    id: 'animals',
    title: 'Animals',
    icon: '🦁',
    description: 'Discover habitats, amazing creatures, and how animals live around the world.',
    exploreQuery: 'interesting animals and wildlife facts for kids',
    gradient:
      'linear-gradient(145deg, rgba(34, 197, 94, 0.35) 0%, rgba(16, 185, 129, 0.2) 45%, var(--color-bg-card) 100%)',
  },
  {
    id: 'robotics',
    title: 'Robotics',
    icon: '🤖',
    description: 'Learn how machines think, move, and help people in everyday life.',
    exploreQuery: 'how robots work simple explanation for kids',
    gradient:
      'linear-gradient(145deg, rgba(99, 102, 241, 0.35) 0%, rgba(59, 130, 246, 0.22) 50%, var(--color-bg-card) 100%)',
  },
  {
    id: 'math',
    title: 'Math Adventures',
    icon: '🔢',
    description: 'Play with numbers, patterns, puzzles, and real-world math stories.',
    exploreQuery: 'fun math games and number patterns for kids',
    gradient:
      'linear-gradient(145deg, rgba(249, 115, 22, 0.28) 0%, rgba(234, 179, 8, 0.2) 50%, var(--color-bg-card) 100%)',
  },
  {
    id: 'space',
    title: 'Space Missions',
    icon: '🚀',
    description: 'Tour planets, stars, and missions that explore the universe.',
    exploreQuery: 'space planets and stars facts for kids',
    gradient:
      'linear-gradient(145deg, rgba(124, 58, 237, 0.32) 0%, rgba(14, 165, 233, 0.22) 55%, var(--color-bg-card) 100%)',
  },
  {
    id: 'pebbles',
    title: 'Hearts',
    icon: '🩷',
    description: 'Kindness, feelings, and the courage to be a good friend.',
    exploreQuery: 'kindness and feelings for kids being a good friend',
    gradient:
      'linear-gradient(145deg, rgba(244, 114, 182, 0.35) 0%, rgba(251, 191, 36, 0.22) 50%, var(--color-bg-card) 100%)',
  },
  {
    id: 'oceans',
    title: 'Oceans',
    icon: '🌊',
    description: 'Dive into coral reefs, ocean life, and how we protect blue waters.',
    exploreQuery: 'ocean animals and coral reefs for kids',
    gradient:
      'linear-gradient(145deg, rgba(14, 165, 233, 0.35) 0%, rgba(6, 182, 212, 0.2) 50%, var(--color-bg-card) 100%)',
  },
  {
    id: 'science-lab',
    title: 'Science Lab',
    icon: '🧪',
    description: 'Curious questions, simple experiments, and how scientists discover answers.',
    exploreQuery: 'easy science experiments and discoveries for kids',
    gradient:
      'linear-gradient(145deg, rgba(236, 72, 153, 0.25) 0%, rgba(168, 85, 247, 0.22) 50%, var(--color-bg-card) 100%)',
  },
];

/** Filtered list for the home grid; remove ids from HIDDEN_UNTIL_GUIDED_LESSONS when paths ship. */
export const EXPLORE_WORLDS = ALL_EXPLORE_WORLDS.filter(
  (w) => !HIDDEN_UNTIL_GUIDED_LESSONS.has(w.id),
);
